import React from 'react';
import { selectDropDown, uiDeviceDetect } from '../../../../Utils/LoadModule';
import { Taxon } from '../../../../Services/FeatchTaxon';
import { FilterTaxonsProps, DropdownItem, SelectProps } from '../../../../interfaces/Filters';
import { BarHr, SelectDropDownStyle } from '../../../Styled/FilterStyle';
const useDeviceDetect = await uiDeviceDetect();

const SelectDropDown = selectDropDown();

const FilterTaxon: React.FC<FilterTaxonsProps & { onClick?: () => void; showFilter: boolean }> = ({
    taxons,
    title,
    itemsToDeselect,
    showFilter,
    onSelect,
}) => {
    const { isMobile } = useDeviceDetect();

    const selectProps: SelectProps = {
        dropdownTitle: title,
        items: taxons.map((taxon: Taxon) => ({
            type: 'item',
            title: taxon.name,
            value: taxon.code,
        })),
        multiSelect: true,
        closeOnOutsideClick: false,
        itemsToDeselect: itemsToDeselect,
        onSelect: (selectedItems: DropdownItem[], event?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (event && event.target instanceof HTMLElement) {
                const key = event.target.getAttribute('data-key');

                if (key) {
                    onSelect(selectedItems, event, key);
                }
            }
        },
    };

    const numberOfItems = taxons.length;

    return (
        <SelectDropDownStyle className='column'>
            <SelectDropDown {...selectProps} />
            {isMobile && <BarHr $margintop={showFilter ? numberOfItems * 12 : 10} />}
        </SelectDropDownStyle>
    );
};

export default FilterTaxon;
